import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';

export type ProLightCircleExclamationProps = IconComponentProps;

export const ProLightCircleExclamation = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCircleExclamationProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCircleExclamation}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCircleExclamation}
    />
  );
};

ProLightCircleExclamation.displayName = 'ProLightCircleExclamation';
